<template>
	<modal @close="cancel" dialog="modal-lg" class="dark-top" :header="true" :customClass="'heightAuto'" :footer="true">
		<div slot="title" class="py-3">
			<span class="fs-larger">Rebook reservation to <span class="fs-larger" style="text-decoration: underline;">{{startHour(event)}} </span></span>
		</div>
		<div slot="body" class="p-4 ml-3">
			<div class="my-1">
				<span class="fs-medium bold mb-1 text-center">Prices might be different:</span>
			</div>
      		<div class="col-sm-12 border-bottom mb-3">
			  	<div class="d-flex py-4 justify-content-between">
					<div class=" col-sm-6 text-center"> 
						<label class="pb-2 fs-normal">Current Reservation</label>
						<ul v-for="current in currentPrice" >
							<li v-if="!current.hide">{{current.quantity}}x  {{current.audienceTypeDescription}}   
								{{current.audienceTypeLabel}}
								<span v-if="!getBookingComparisonRebook.hideCategoryPrices">: {{current.grossprice}}€</span>
							</li>
						</ul>
						<span class="bold"> Total: {{getBookingComparisonRebook.bookingCurrentPrice}}€ </span>
					</div>
				</div> 
			  	<div class="d-flex py-4 justify-content-between">
					<div class=" col-sm-6 text-center"> 
						<label class="pb-2 fs-normal">New Reservation - Keep</label>
						<ul v-for="current in priceNewKeep" >
							<li v-if="!current.hide">{{current.quantity}}x  {{current.audienceTypeDescription}}   
								{{current.audienceTypeLabel}}
								<span v-if="!getBookingComparisonRebook.hideCategoryPrices">: {{current.grossprice}}€</span>
							</li>
						</ul>
						<span class="bold"> Total: {{getBookingComparisonRebook.bookingCurrentPrice}}€ </span>
					</div>
					<div class="col-sm-6 text-center"> 
						<label class="pb-2 fs-normal">New Reservation - Change</label>
						<ul v-for="newprice in priceNewChange" >
							<li v-if="!newprice.hide">{{newprice.quantity}}x  {{newprice.audienceTypeDescription}}  
								{{newprice.audienceTypeLabel}}
								<span v-if="!getBookingComparisonRebook.hideCategoryPrices">: {{newprice.grossprice}}€</span>
							</li>
						</ul>
						<span class="bold"> Total: {{getBookingComparisonRebook.bookingNewPrice}}€ </span>
					</div>
				</div> 
      		</div>

			<AlertMessage v-if="!isMinLimitsSatisfied" 
				:message="minLimitsMessage" 
				icon="ico-alert" bold />
			
			<AlertMessage v-if="!isMaxLimitsSatisfied" 
				:message="maxLimitsMessage" 
				icon="ico-alert" bold />

			<AlertMessage v-if="!hasMinPaxPerEvent" 
				:message="minPaxPerEventMessage" 
				icon="ico-message" bold
			/>
			
			<div class="mt-4">
       			<span class="fs-normal text-center">Do you want to  <span class="bold"> Keep </span> or <span class="bold"> Change </span> the price of the reservation? </span>
			</div>
    </div>
    <div slot="footer" class="d-flex justify-content-between">
      <button type="button" class="btn cancel wider" @click="cancel">Cancel</button>
      <div>
        <button type="button" class="btn ok wider" :disabled="getIsRescheduling || isRescheduling" @click="keepPrices">Keep</button>
        <button  type="button" class="btn ok wider" :disabled="getIsRescheduling || isRescheduling" @click="changePrices">Change</button>
      </div>
    </div>
  </modal>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { reservationsMixin } from '@/mixins/reservations'
import AlertMessage from '../alertMessage/AlertMessage';
import Modal from './Modal'

export default {
	mixins:[
		reservationsMixin
	],
	mounted: async function () {
		this.reservation = this.getClonedReservation
	},
	data: function() {
		return {
			reservation: null,
			isToUpdateGenderPrices: false,
			isRescheduling: false,
		}
	},
	computed: {
		...mapGetters([
			'account',
			'getBookingComparisonRebook',
			'getNewEventRebook',
			'getClonedReservation',
			'getIsRescheduling'
		]),
		bookingComparisonRebook() {
			return this.getBookingComparisonRebook.bookingGenderPriceComparisonResults;
		},
		currentPrice() {
			let current = this.bookingComparisonRebook.map(price => {
				return price.bookingGenderPriceCurrent;
			});
			
			return current;
		},
		priceNewChange() {
			let priceNewChange = this.bookingComparisonRebook.map(price => {
				return price.bookingGenderPriceNew;
			});

			return priceNewChange;
		},
		priceNewKeep() {
			let priceNewKeep = this.bookingComparisonRebook.map(price => {
				return price.bookingGenderPriceNewKeep;
			});

			return priceNewKeep;
		},
		event() {
			return this.getNewEventRebook.event;
		},
        isMaxLimitsSatisfied() {
            return this.getNewEventRebook.isMaxLimitsSatisfied;
        },
        isMinLimitsSatisfied() {
            return this.getNewEventRebook.isMinLimitsSatisfied;
        },
        rejectBookingBasedOnMinMax() {
            return this.getNewEventRebook.rejectBookingBasedOnMinMax;
        },
		hasMinPaxPerEvent() {
			return this.getNewEventRebook.event.minimumLotation === 0 ? true : this.getNewEventRebook.event.quantityBooked < this.getNewEventRebook.event.minimumLotation ? false : true;
		},
		minLimitsMessage() {
			return `Below minimum people required per booking (${this.getNewEventRebook.event.minimumPaxPerBooking} PAX) for this reservation.`;
		},
		maxLimitsMessage() {
			return `Exceeds maximum people allowed per booking (${this.getNewEventRebook.event.maximumPaxPerBooking} PAX) for this reservation.`;
		},
		minPaxPerEventMessage() {
			return `A minimum of ${this.getNewEventRebook.event.minimumLotation} PAX per event is required, otherwise the booking remains pending confirmation. (Booked: ${this.getNewEventRebook.event.quantityBooked})`;
		}
  	},
	methods: {
		...mapActions([
			'rescheduleExistingReservation',
			'addFloatingNotification',
			'closeModal',
			'clearClonedReservation',
		]),
		startHour(event) {
			return moment(event.start).format("DD-MM-YYYY") + ' at '+ moment(event.start).format("HH:mm");
		},
		changePrices() {
			this.isRescheduling = true;
			this.isToUpdateGenderPrices = true
			this.registerReschedule(this.event)
		},
		keepPrices() {
			this.isRescheduling = true;
			this.isToUpdateGenderPrices = false
			this.registerReschedule(this.event)
		},
		cancel() {
			this.closeModal();
		},
		registerReschedule(event) {
			this.rescheduleExistingReservation({
				supplierId: this.account.supplierId,
				deliverNotification: false,
				event: event,
				booking: this.reservation,
				isToUpdateGenderPrices:this.isToUpdateGenderPrices
			}).then(response => {
				this.addFloatingNotification(
					{
						type: -1,
						title: 'Ticket '+this.formatTicketNumber(response.data.id),
						message: response.data.customer.name+' <br>'+response.data.event.product.name,
						bookingId: response.data.id,
					},
					'info',
					{ link: '/reservations/view/'+response.data.id }
				)

				this.isRescheduling = false;
				
				this.closeModal();
				this.clearClonedReservation();
				this.$router.push('/reservations')
			}).catch(() => {
				this.isRescheduling = false;
			})
		},
  	},
  	components: {
      	Modal,
		AlertMessage
    }
};
</script>



// WEBPACK FOOTER //
// CompareEventsRebook.vue?7e75855a